export const DDC_ICON_PREFIX = 'ddc-icon-';

// WIAPI page modify locations
export const SERVICE_SCHEDULE_BUTTON = 'schedule-service';

// Flags
export const FLAG_LATENCY_TRACKING = 'ws-content-cta-latency-tracking';
export const FLAG_CONTENT_CTA_ATF = 'ws-content-cta-render-atf'; // US1133164

// Icon types
export const SYSTEM = 'system';
export const SPOT = 'spot';

// Default resize images for desktop and mobile
export const RESIZE_DEFAULT_DESKTOP = 640;
export const RESIZE_DEFAULT_MOBILE = 410;
export const BLANK_GIF =
	'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
